import React, { useContext } from 'react';
import styled from 'styled-components';
import { FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core';
import StorageIcon from '@material-ui/icons/Storage';
import { UserContext } from '../../contexts/UserContext';
import { SubHeading } from '../../components/ui/SubHeading';

const DataSettings = () => {
  const { Site, handleSiteChange } = useContext(UserContext);
  const patronLabel =
    Site.siteType === 0 || Site.siteType === 5 ? 'students' : 'staff';
  return (
    <>
      <SubHeading>
        {' '}
        <StorageIcon style={Iconstyles} /> Data
      </SubHeading>

      <Checkboxes>
        <FormControlLabel
          control={
            <Checkbox
              name='deletableRecords'
              onChange={handleSiteChange}
              checked={Site.deletableRecords}
            />
          }
          label='Allow records to be deleted'
        />
        <FormHelperText>
          If enabled, you are able to delete individual {patronLabel} from your
          list
        </FormHelperText>
      </Checkboxes>
    </>
  );
};

 const Iconstyles = {
   fontSize: '17px',
 };

const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.1rem;
`;

export default DataSettings;
